import React from "react";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import highchartsMore from 'highcharts/highcharts-more'; // Import modul untuk bubble chart
import { Card } from "react-bootstrap";
import { GrowthReportResponseTypeV4 } from "../../../../services/cm-growth-report/response/GrowthReportResponseV4";

// Inisialisasi modul 'highcharts-more' yang berisi tipe bubble chart
highchartsMore(Highcharts);

interface BubbleHighchartsV4Props {
    data: GrowthReportResponseTypeV4;
    comparison: { from: number; to: number };
}

const BubbleHighchartsV4: React.FC<BubbleHighchartsV4Props> = ({ data, comparison }) => {

    const chartData = data.map((property) => {
        const relevantComparison = property.comparisons.find(
            c => c.from_period === comparison.from && c.to_period === comparison.to
        );
        const basePeriod = property.periods.find(
            p => p.period_index === comparison.from
        );

        if (!relevantComparison || !basePeriod) {
            return null;
        }

        return {
            x: relevantComparison.room_night_growth,
            y: relevantComparison.revenue_growth,
            z: basePeriod.revenue,
            name: property.property_name,
        };
    }).filter((item): item is NonNullable<typeof item> => item !== null);

    if (chartData.length === 0) {
        return <p className="text-center mt-3">No data available for this comparison.</p>;
    }

    // ================== LOGIKA BARU DIMULAI DI SINI ==================

    // 1. Ekstrak semua nilai x dan y
    const xValues = chartData.map(d => d.x);
    const yValues = chartData.map(d => d.y);

    // 2. Tentukan padding (jarak dari bubble terluar ke tepi chart)
    const padding = 2; // Anda bisa mengubah nilai ini

    // 3. Hitung batas min/max untuk setiap sumbu
    const minX = Math.min(...xValues) - padding;
    const maxX = Math.max(...xValues) + padding;
    const minY = Math.min(...yValues) - padding;
    const maxY = Math.max(...yValues) + padding;

    // =================================================================

    const getOptions = (): Highcharts.Options => ({
        chart: {
            type: 'bubble',
            backgroundColor: 'transparent'
        },
        title: {
            text: 'Comparison of growth properties in the selected period'
        },
        xAxis: {
            title: {
                text: 'Room Night Growth (%)'
            },
            labels: {
                format: '{value}%'
            },
            // 4. Terapkan batas min/max yang sudah dihitung
            min: minX,
            max: maxX,
            tickInterval: 1 // Ubah interval menjadi 1 agar lebih detail
        },
        yAxis: {
            title: {
                text: 'Revenue Growth (%)'
            },
            labels: {
                format: '{value}%'
            },
            // 4. Terapkan batas min/max yang sudah dihitung
            min: minY,
            max: maxY,
            tickInterval: 1 // Ubah interval menjadi 1 agar lebih detail
        },
        tooltip: {
            pointFormatter: function () {
                const point = this as any;
                return `<b>${point.name}</b><br/>` +
                    `Room Night Growth: ${point.x}%<br/>` +
                    `Revenue Growth: ${point.y}%<br/>` +
                    `Base Revenue: ${Highcharts.numberFormat(point.z, 0, ',', '.')}`;
            },
            headerFormat: ''
        },
        legend: {
            enabled: true,
        },
        plotOptions: {
            bubble: {
                dataLabels: {
                    enabled: true,
                    format: '{point.name}',
                    style: {
                        color: 'black',
                        textOutline: 'none',
                        fontWeight: 'normal',
                        fontSize: '10px'
                    }
                },
                minSize: '5%',
                maxSize: '25%'
            }
        },
        series: [{
            type: 'bubble',
            name: 'Properties',
            data: chartData
        }] as Highcharts.SeriesOptionsType[],
        credits: {
            enabled: false
        }
    });

    return (
        <Card className="h-100 shadow">
            <Card.Body>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={getOptions()}
                    containerProps={{ style: { height: '400px', width: '100%' } }}
                />
            </Card.Body>
        </Card>
    );
};

export default BubbleHighchartsV4;